{
  "post-office.rovo-extension-install-cta-rovo-chat-input.banner-cta-button": [
    {
      "type": 0,
      "value": "Get extension"
    }
  ],
  "post-office.rovo-extension-install-cta-rovo-chat-input.banner-description-compact": [
    {
      "type": 0,
      "value": "Install the Chrome extension for instant, trusted answers anywhere you browse."
    }
  ],
  "post-office.rovo-extension-install-cta-rovo-chat-input.banner-description-wide": [
    {
      "type": 0,
      "value": "Download the Chrome extension to use Rovo in your browser. Get instant answers from trusted sources"
    }
  ],
  "post-office.rovo-extension-install-cta-rovo-chat-input.banner-dismiss-button": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.rovo-extension-install-cta-rovo-chat-input.banner-title": [
    {
      "type": 0,
      "value": "Use Rovo everywhere"
    }
  ],
  "rovo-button-onboarding-spotlight.copy-version-a.bodyText": [
    {
      "type": 0,
      "value": "Connect the dots, simplify writing, and move projects forward."
    }
  ],
  "rovo-button-onboarding-spotlight.copy-version-a.headlineText": [
    {
      "type": 0,
      "value": "Your AI teammate is here"
    }
  ],
  "rovo-button-onboarding-spotlight.getStartedButtonLabel": [
    {
      "type": 0,
      "value": "Get started"
    }
  ],
  "rovo-expansion.base-3p-rovo-email.body.branded-header.description": [
    {
      "type": 0,
      "value": "Atlassian Rovo branded header"
    }
  ],
  "rovo-expansion.base-3p-rovo-email.title": [
    {
      "type": 0,
      "value": "Atlassian Rovo"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.add-connectors-button": [
    {
      "type": 0,
      "value": "Add connectors"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.adobe.alt": [
    {
      "type": 0,
      "value": "Adobe Sign logo"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.adobe.body": [
    {
      "type": 0,
      "value": "Find the Adobe Sign agreements your team needs with ease"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.adobe.heading": [
    {
      "type": 0,
      "value": "Adobe Sign"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.aha.alt": [
    {
      "type": 0,
      "value": "Aha! logo"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.aha.body": [
    {
      "type": 0,
      "value": "Quickly locate Aha! features you need"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.aha.heading": [
    {
      "type": 0,
      "value": "Aha"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.airtable.alt": [
    {
      "type": 0,
      "value": "Airtable logo"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.airtable.body": [
    {
      "type": 0,
      "value": "Bring your data and records and make them searchable alongside your company knowledge"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.airtable.heading": [
    {
      "type": 0,
      "value": "Airtable"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.asana.alt": [
    {
      "type": 0,
      "value": "Asana logo"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.asana.body": [
    {
      "type": 0,
      "value": "Locate your team's work by searching Asana's tasks and subtasks"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.asana.heading": [
    {
      "type": 0,
      "value": "Asana"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.azure.alt": [
    {
      "type": 0,
      "value": "Azure DevOps logo"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.azure.body": [
    {
      "type": 0,
      "value": "Quickly retrieve your Azure DevOps repositories"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.azure.heading": [
    {
      "type": 0,
      "value": "Azure DevOps"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.box.alt": [
    {
      "type": 0,
      "value": "Box logo"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.box.body": [
    {
      "type": 0,
      "value": "Search all your documents, spreadsheets, and presentations alongside your company knowledge"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.box.heading": [
    {
      "type": 0,
      "value": "Box"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.connect-button": [
    {
      "type": 0,
      "value": "Connect"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.docusign.alt": [
    {
      "type": 0,
      "value": "DocuSign logo"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.docusign.body": [
    {
      "type": 0,
      "value": "Make your important envelopes findable alongside your company knowledge"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.docusign.heading": [
    {
      "type": 0,
      "value": "DocuSign"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.dropbox.alt": [
    {
      "type": 0,
      "value": "Dropbox logo"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.dropbox.body": [
    {
      "type": 0,
      "value": "Bring in your documents, spreadsheets, and presentations "
    }
  ],
  "rovo-expansion.email.body.app-connect-card.dropbox.heading": [
    {
      "type": 0,
      "value": "Dropbox"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.gear.alt": [
    {
      "type": 0,
      "value": "Add connectors icon"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.gear.body": [
    {
      "type": 0,
      "value": "Add or remove your connected apps at anytime."
    }
  ],
  "rovo-expansion.email.body.app-connect-card.gear.heading": [
    {
      "type": 0,
      "value": "You’re always in control"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.github.alt": [
    {
      "type": 0,
      "value": "GitHub logo"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.github.body": [
    {
      "type": 0,
      "value": "Integrate your development workflow and search across your PRs, issues, commits, and repos"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.github.heading": [
    {
      "type": 0,
      "value": "GitHub"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.gitlab.alt": [
    {
      "type": 0,
      "value": "GitLab logo"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.gitlab.body": [
    {
      "type": 0,
      "value": "Find your Gitlab repositories easily"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.gitlab.heading": [
    {
      "type": 0,
      "value": "GitLab"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.google-drive.alt": [
    {
      "type": 0,
      "value": "Google Drive logo"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.google-drive.body": [
    {
      "type": 0,
      "value": "Get insights and answers from docs and integrate your files into a unified search"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.google-drive.heading": [
    {
      "type": 0,
      "value": "Google Drive"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.lucid.alt": [
    {
      "type": 0,
      "value": "Lucid logo"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.lucid.body": [
    {
      "type": 0,
      "value": "Make your documents and visual collaboration searchable alongside your company knowledge"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.lucid.heading": [
    {
      "type": 0,
      "value": "Lucid"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.miro.alt": [
    {
      "type": 0,
      "value": "Miro logo"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.miro.body": [
    {
      "type": 0,
      "value": "Make all your brainstorming and planning boards searchable alongside your company knowledge"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.miro.heading": [
    {
      "type": 0,
      "value": "Miro"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.ms-teams.alt": [
    {
      "type": 0,
      "value": "Microsoft Teams"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.ms-teams.body": [
    {
      "type": 0,
      "value": "Make all your messages part of your company knowledge"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.ms-teams.heading": [
    {
      "type": 0,
      "value": "Microsoft Teams"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.notion.alt": [
    {
      "type": 0,
      "value": "Notion logo"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.notion.body": [
    {
      "type": 0,
      "value": "Add your pages and make them searchable alongside your company knowledge"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.notion.heading": [
    {
      "type": 0,
      "value": "Notion"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.onedrive.alt": [
    {
      "type": 0,
      "value": "OneDrive logo"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.onedrive.body": [
    {
      "type": 0,
      "value": "Search across documents, spreadsheets, and presentations"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.onedrive.heading": [
    {
      "type": 0,
      "value": "OneDrive"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.sharepoint.alt": [
    {
      "type": 0,
      "value": "Sharepoint logo"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.sharepoint.body": [
    {
      "type": 0,
      "value": "Get answers from your SharePoint documents and bring your files alongside your company knowledge"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.sharepoint.heading": [
    {
      "type": 0,
      "value": "Sharepoint"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.slack.alt": [
    {
      "type": 0,
      "value": "Slack logo"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.slack.body": [
    {
      "type": 0,
      "value": "Make every thread and channel part of your company knowledge"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.slack.heading": [
    {
      "type": 0,
      "value": "Slack"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.smartsheet.alt": [
    {
      "type": 0,
      "value": "Smartsheet logo"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.smartsheet.body": [
    {
      "type": 0,
      "value": "Access your Smartsheet sheets"
    }
  ],
  "rovo-expansion.email.body.app-connect-card.smartsheet.heading": [
    {
      "type": 0,
      "value": "Smartsheet"
    }
  ],
  "rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.heading-1": [
    {
      "type": 0,
      "value": "Your Chat just got more powerful with "
    },
    {
      "type": 1,
      "value": "connected3PApp"
    }
  ],
  "rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.introduction": [
    {
      "type": 0,
      "value": "Now that you’ve connected "
    },
    {
      "type": 1,
      "value": "connected3PApp"
    },
    {
      "type": 0,
      "value": ", you’ll find results that include all its files and context. Try using these prompts to get started:"
    }
  ],
  "rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.prompt.find-latest-work": [
    {
      "type": 0,
      "value": "\"Find my team’s latest work from "
    },
    {
      "type": 1,
      "value": "connected3PApp"
    },
    {
      "type": 0,
      "value": "\""
    }
  ],
  "rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.prompt.link": [
    {
      "type": 0,
      "value": "Try prompt"
    }
  ],
  "rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.prompt.show-files": [
    {
      "type": 0,
      "value": "\"Show me all files that mention me in "
    },
    {
      "type": 1,
      "value": "connected3PApp"
    },
    {
      "type": 0,
      "value": "\""
    }
  ],
  "rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.prompt.summarise-latest-project": [
    {
      "type": 0,
      "value": "\"Summarize my latest project in "
    },
    {
      "type": 1,
      "value": "connected3PApp"
    },
    {
      "type": 0,
      "value": " in a couple of sentences\""
    }
  ],
  "rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.title": [
    {
      "type": 0,
      "value": "Try 3 prompts to instantly improve your search with "
    },
    {
      "type": 1,
      "value": "connected3PApp"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.email.body.know-more.heading": [
    {
      "type": 0,
      "value": "Want to know more?"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.email.body.know-more.subheading": [
    {
      "type": 0,
      "value": "Learn about managing connectors, your data, and permissions."
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.email.body.recommended-for-you.heading": [
    {
      "type": 0,
      "value": "Recommended for you"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.email.body.recommended-for-you.subheading": [
    {
      "type": 0,
      "value": "Connect the apps your team is already using."
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.email.body.rovo.heading": [
    {
      "type": 0,
      "value": "Get better results by connecting your apps with Rovo"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.email.body.rovo.subheading.gear-variant": [
    {
      "type": 0,
      "value": "Smarter search and chat starts with connected apps. App permissions are always respected."
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.email.body.rovo.subheading.text-variant": [
    {
      "type": 0,
      "value": "Smarter search and chat starts with connected apps. Rovo respects existing app permissions, and "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "you can add or remove connectors at any time."
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.add-connectors-button": [
    {
      "type": 0,
      "value": "Add connectors"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.adobe.alt": [
    {
      "type": 0,
      "value": "Adobe Sign logo"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.adobe.body": [
    {
      "type": 0,
      "value": "Find the Adobe Sign agreements your team needs with ease"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.adobe.heading": [
    {
      "type": 0,
      "value": "Adobe Sign"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.aha.alt": [
    {
      "type": 0,
      "value": "Aha! logo"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.aha.body": [
    {
      "type": 0,
      "value": "Quickly locate Aha! features you need"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.aha.heading": [
    {
      "type": 0,
      "value": "Aha"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.airtable.alt": [
    {
      "type": 0,
      "value": "Airtable logo"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.airtable.body": [
    {
      "type": 0,
      "value": "Bring your data and records and make them searchable alongside your company knowledge"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.airtable.heading": [
    {
      "type": 0,
      "value": "Airtable"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.asana.alt": [
    {
      "type": 0,
      "value": "Asana logo"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.asana.body": [
    {
      "type": 0,
      "value": "Locate your team's work by searching Asana's tasks and subtasks"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.asana.heading": [
    {
      "type": 0,
      "value": "Asana"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.azure.alt": [
    {
      "type": 0,
      "value": "Azure DevOps logo"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.azure.body": [
    {
      "type": 0,
      "value": "Quickly retrieve your Azure DevOps repositories"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.azure.heading": [
    {
      "type": 0,
      "value": "Azure DevOps"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.box.alt": [
    {
      "type": 0,
      "value": "Box logo"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.box.body": [
    {
      "type": 0,
      "value": "Search all your documents, spreadsheets, and presentations alongside your company knowledge"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.box.heading": [
    {
      "type": 0,
      "value": "Box"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.connect-banner.description": [
    {
      "type": 0,
      "value": "Banner image showing Rovo app connectors"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.connect-button": [
    {
      "type": 0,
      "value": "Connect"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.docusign.alt": [
    {
      "type": 0,
      "value": "DocuSign logo"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.docusign.body": [
    {
      "type": 0,
      "value": "Make your important envelopes findable alongside your company knowledge"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.docusign.heading": [
    {
      "type": 0,
      "value": "DocuSign"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.dropbox.alt": [
    {
      "type": 0,
      "value": "Dropbox logo"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.dropbox.body": [
    {
      "type": 0,
      "value": "Bring in your documents, spreadsheets, and presentations "
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.dropbox.heading": [
    {
      "type": 0,
      "value": "Dropbox"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.atlassian-logo-alt": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.contact-us": [
    {
      "type": 0,
      "value": "Contact us"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved. "
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.facebook-title": [
    {
      "type": 0,
      "value": "Facebook"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.linkedin-title": [
    {
      "type": 0,
      "value": "LinkedIn"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.office-address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.privacy-policy": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.read-our-blog": [
    {
      "type": 0,
      "value": "Read our blog"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.separator": [
    {
      "type": 0,
      "value": " • "
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.unsubscribe": [
    {
      "children": [
        {
          "type": 0,
          "value": "Unsubscribe"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " to opt out of future emails like this"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.x-title": [
    {
      "type": 0,
      "value": "X"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.gear.alt": [
    {
      "type": 0,
      "value": "Add connectors icon"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.gear.body": [
    {
      "type": 0,
      "value": "Add or remove your connected apps at anytime."
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.gear.heading": [
    {
      "type": 0,
      "value": "You’re always in control"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.github.alt": [
    {
      "type": 0,
      "value": "GitHub logo"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.github.body": [
    {
      "type": 0,
      "value": "Integrate your development workflow and search across your PRs, issues, commits, and repos"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.github.heading": [
    {
      "type": 0,
      "value": "GitHub"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.gitlab.alt": [
    {
      "type": 0,
      "value": "GitLab logo"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.gitlab.body": [
    {
      "type": 0,
      "value": "Find your Gitlab repositories easily"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.gitlab.heading": [
    {
      "type": 0,
      "value": "GitLab"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.google-drive.alt": [
    {
      "type": 0,
      "value": "Google Drive logo"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.google-drive.body": [
    {
      "type": 0,
      "value": "Get insights and answers from docs and integrate your files into a unified search"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.google-drive.heading": [
    {
      "type": 0,
      "value": "Google Drive"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.lucid.alt": [
    {
      "type": 0,
      "value": "Lucid logo"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.lucid.body": [
    {
      "type": 0,
      "value": "Make your documents and visual collaboration searchable alongside your company knowledge"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.lucid.heading": [
    {
      "type": 0,
      "value": "Lucid"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.miro.alt": [
    {
      "type": 0,
      "value": "Miro logo"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.miro.body": [
    {
      "type": 0,
      "value": "Make all your brainstorming and planning boards searchable alongside your company knowledge"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.miro.heading": [
    {
      "type": 0,
      "value": "Miro"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.monday.alt": [
    {
      "type": 0,
      "value": "Monday logo"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.monday.body": [
    {
      "type": 0,
      "value": "Centralize your Monday boards seamlessly"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.monday.heading": [
    {
      "type": 0,
      "value": "Monday"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.ms-teams.alt": [
    {
      "type": 0,
      "value": "Microsoft Teams"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.ms-teams.body": [
    {
      "type": 0,
      "value": "Make all your messages part of your company knowledge"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.ms-teams.heading": [
    {
      "type": 0,
      "value": "Microsoft Teams"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.notion.alt": [
    {
      "type": 0,
      "value": "Notion logo"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.notion.body": [
    {
      "type": 0,
      "value": "Add your pages and make them searchable alongside your company knowledge"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.notion.heading": [
    {
      "type": 0,
      "value": "Notion"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.onedrive.alt": [
    {
      "type": 0,
      "value": "OneDrive logo"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.onedrive.body": [
    {
      "type": 0,
      "value": "Search across documents, spreadsheets, and presentations"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.onedrive.heading": [
    {
      "type": 0,
      "value": "OneDrive"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.slack.alt": [
    {
      "type": 0,
      "value": "Slack logo"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.slack.body": [
    {
      "type": 0,
      "value": "Make every thread and channel part of your company knowledge"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.slack.heading": [
    {
      "type": 0,
      "value": "Slack"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.smartsheet.alt": [
    {
      "type": 0,
      "value": "Smartsheet logo"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.smartsheet.body": [
    {
      "type": 0,
      "value": "Access your Smartsheet sheets"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.smartsheet.heading": [
    {
      "type": 0,
      "value": "Smartsheet"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.subject": [
    {
      "type": 0,
      "value": "Connect the apps your team depends on"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.banner.description": [
    {
      "type": 0,
      "value": "Decorative banner image"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.flow-state.description": [
    {
      "type": 0,
      "value": "Turn scattered files into accessible knowledge, without compromising on security and permissions"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.flow-state.headline": [
    {
      "type": 0,
      "value": "Expand organizational knowledge"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.flow-state.icon.description": [
    {
      "type": 0,
      "value": "Flow state icon"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.heading": [
    {
      "type": 0,
      "value": "Finish connecting "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " to give your team a more intuitive way to search"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.heading-subtext": [
    {
      "type": 0,
      "value": "Centralize the search for your team’s files so they’ll always have the knowledge and context they need."
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.page-search.description": [
    {
      "type": 0,
      "value": "Getting rich, contextual results in search and chat"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.page-search.headline": [
    {
      "type": 0,
      "value": "Find better answers instantly"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.page-search.icon.description": [
    {
      "type": 0,
      "value": "Page search icon"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.platform.description": [
    {
      "type": 0,
      "value": "Reducing context switching to focus on the work that matters"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.platform.headline": [
    {
      "type": 0,
      "value": "Stay concentrated in their workflow"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.platform.icon.description": [
    {
      "type": 0,
      "value": "Platform icon"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.rovo.heading-after-connecting": [
    {
      "type": 0,
      "value": "With your help, they’ll be able to:"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-follow-up.email.subject": [
    {
      "type": 0,
      "value": "Unblock your team’s work: finish connecting "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ],
  "rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.banner.description": [
    {
      "type": 0,
      "value": "Banner image showing Rovo app connectors"
    }
  ],
  "rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.flow-state.description": [
    {
      "type": 0,
      "value": "Connect related work across tools, teams, and projects so knowledge never stays siloed"
    }
  ],
  "rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.flow-state.icon.description": [
    {
      "type": 0,
      "value": "Flow state icon"
    }
  ],
  "rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.page-search.description": [
    {
      "type": 0,
      "value": "Get richer answers in Search and Chat, not just links"
    }
  ],
  "rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.page-search.icon.description": [
    {
      "type": 0,
      "value": "Page search icon"
    }
  ],
  "rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.platform.description": [
    {
      "type": 0,
      "value": "Find content across your entire workspace from a single search"
    }
  ],
  "rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.platform.icon.description": [
    {
      "type": 0,
      "value": "Platform icon"
    }
  ],
  "rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.rovo.heading-after-connecting": [
    {
      "type": 0,
      "value": "After connecting your app, you’ll be able to:"
    }
  ],
  "rovo-expansion.rovo-3p-enduser-auth-post-admin.email.heading-subtext.more-than-one-app": [
    {
      "type": 0,
      "value": "Your admin just added the following apps. Finish connecting your account to find contextual results that include all your work in a single search."
    }
  ],
  "rovo-expansion.rovo-3p-enduser-auth-post-admin.email.heading-subtext.one-app": [
    {
      "type": 0,
      "value": "Your admin just added "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": ". Finish connecting your account to find contextual results that include all your work in a single search."
    }
  ],
  "rovo-expansion.rovo-3p-enduser-auth-post-admin.email.heading.one-app": [
    {
      "type": 0,
      "value": "Connect "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " to get more in-depth answers"
    }
  ],
  "rovo-expansion.rovo-3p-enduser-auth-post-admin.email.heading.three-or-more-apps": [
    {
      "type": 0,
      "value": "Connect "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " and other apps to get more in-depth answers "
    }
  ],
  "rovo-expansion.rovo-3p-enduser-auth-post-admin.email.heading.two-apps": [
    {
      "type": 0,
      "value": "Connect "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "appName2"
    },
    {
      "type": 0,
      "value": " to get more in-depth answers"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.email.body.greeting": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.email.body.hello.subtext": [
    {
      "type": 0,
      "value": "Love using Rovo? Take it to the next level with the Rovo browser extension."
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.branded-header.description": [
    {
      "type": 0,
      "value": "Atlassian Rovo logo"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.chat-that-knows-your-context-section.description": [
    {
      "type": 0,
      "value": "Chat that knows your context. Ask questions about what’s open. Get context, fast."
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.chat-that-knows-your-context-section.heading": [
    {
      "type": 0,
      "value": "Chat that knows your context"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.chat-that-knows-your-context-section.subtext": [
    {
      "type": 0,
      "value": "Ask questions about whatever tab is open. Get context, fast."
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.create-what-you-need-fast-section.description": [
    {
      "type": 0,
      "value": "Create what you need, fast. Instant work items across Jira, Confluence, Loom, and Agents. Make teamwork easy."
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.create-what-you-need-fast-section.heading": [
    {
      "type": 0,
      "value": "Create what you need, fast"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.create-what-you-need-fast-section.subtext": [
    {
      "type": 0,
      "value": "Instant work items across Jira, Confluence, Loom, and Agents. Make teamwork easy."
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.download-extension": [
    {
      "type": 0,
      "value": "Download the extension"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.extension-screenshot.description": [
    {
      "type": 0,
      "value": "Demo of the extension in action"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.atlassian-logo-alt": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.contact-us": [
    {
      "type": 0,
      "value": "Contact us"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved. "
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.facebook-aria": [
    {
      "type": 0,
      "value": "Facebook"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.facebook-title": [
    {
      "type": 0,
      "value": "Facebook"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.linkedin-aria": [
    {
      "type": 0,
      "value": "LinkedIn"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.linkedin-title": [
    {
      "type": 0,
      "value": "LinkedIn"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.office-address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.privacy-policy": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.read-our-blog": [
    {
      "type": 0,
      "value": "Read our blog"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.separator-1": [
    {
      "type": 0,
      "value": " • "
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.separator-2": [
    {
      "type": 0,
      "value": " • "
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.unsubscribe.full": [
    {
      "type": 0,
      "value": "to opt out of future emails like this"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.unsubscribe.short": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.x-aria": [
    {
      "type": 0,
      "value": "X"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.x-title": [
    {
      "type": 0,
      "value": "X"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.four-icon.description": [
    {
      "type": 0,
      "value": "Four icon"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.instant-answers-section.description": [
    {
      "type": 0,
      "value": "Instant answers. Chat with your company’s knowledge base, right from any browser tab."
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.instant-answers-section.heading": [
    {
      "type": 0,
      "value": "Instant answers"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.instant-answers-section.subtext": [
    {
      "type": 0,
      "value": "Chat with your "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "company’s knowledge"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " base, right from any browser tab."
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.one-icon.description": [
    {
      "type": 0,
      "value": "One icon"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.three-icon.description": [
    {
      "type": 0,
      "value": "Three icon"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.try-it-today": [
    {
      "type": 0,
      "value": "Try it today."
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.two-icon.description": [
    {
      "type": 0,
      "value": "Two icon"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.your-work-in-one-click-section.description": [
    {
      "type": 0,
      "value": "Your work in one click. Pick up where you left off. Rovo's new tab page keeps your recent work ready after that last unexpected interruption."
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.your-work-in-one-click-section.heading": [
    {
      "type": 0,
      "value": "Your work in one click"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.your-work-in-one-click-section.subtext": [
    {
      "type": 0,
      "value": "Pick up where you left off. Rovo's new tab page keeps your recent work ready after that last unexpected interruption."
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.subject": [
    {
      "type": 0,
      "value": "🚀 Try out the Rovo browser extension – Available now"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users.email.body.greeting": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users.email.body.hello.subtext": [
    {
      "type": 0,
      "value": "Love using Rovo? Take it to the next level with the Rovo browser extension."
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users.message-template.email.body.branded-header.description": [
    {
      "type": 0,
      "value": "Atlassian Rovo logo"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users.message-template.email.body.download-extension": [
    {
      "type": 0,
      "value": "Download the extension"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users.message-template.email.body.extension-screenshot.description": [
    {
      "type": 0,
      "value": "Demo of the extension in action"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users.message-template.email.body.make-rovo-your-own": [
    {
      "type": 0,
      "value": "Here’s what you get"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users.message-template.email.body.rovo-extension-features.description": [
    {
      "type": 0,
      "value": "Rovo extension features: Chat with your company’s knowledge base, right from any browser tab. Ask questions about what’s open. Get context that connects back to your projects. Pick up where you left off. Rovo’s new tab page keeps your recent work ready after that last unexpected interruption. Create what you need, fast. Instantly create work items across Jira, Confluence, and Loom. Make teamwork easy."
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users.message-template.email.body.try-it-today": [
    {
      "type": 0,
      "value": "Try it today."
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users.message-template.email.subject": [
    {
      "type": 0,
      "value": "🚀 Try out the Rovo browser extension – Available now"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.email.body.greeting": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.email.body.hello.subtext": [
    {
      "type": 0,
      "value": "Companies are using "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "AI 400% as often"
        }
      ],
      "type": 8,
      "value": "span"
    },
    {
      "type": 0,
      "value": " with the Rovo browser extension. Scale your org’s AI adoption fast."
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.branded-header.description": [
    {
      "type": 0,
      "value": "Atlassian Rovo logo"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.download-extension": [
    {
      "type": 0,
      "value": "Install the extension across your company"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.extension-screenshot.description": [
    {
      "type": 0,
      "value": "Demo of the extension in action"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.atlassian-logo-alt": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.contact-us": [
    {
      "type": 0,
      "value": "Contact us"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved. "
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.facebook-aria": [
    {
      "type": 0,
      "value": "Facebook"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.facebook-title": [
    {
      "type": 0,
      "value": "Facebook"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.linkedin-aria": [
    {
      "type": 0,
      "value": "LinkedIn"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.linkedin-title": [
    {
      "type": 0,
      "value": "LinkedIn"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.office-address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.privacy-policy": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.read-our-blog": [
    {
      "type": 0,
      "value": "Read our blog"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.separator-1": [
    {
      "type": 0,
      "value": " • "
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.separator-2": [
    {
      "type": 0,
      "value": " • "
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.unsubscribe.full": [
    {
      "type": 0,
      "value": "to opt out of future emails like this"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.unsubscribe.short": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.x-aria": [
    {
      "type": 0,
      "value": "X"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.x-title": [
    {
      "type": 0,
      "value": "X"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.make-rovo-your-own": [
    {
      "type": 0,
      "value": "Make Rovo your own"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.ready-to-roll-out": [
    {
      "type": 0,
      "value": "Ready to roll out?"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.rovo-features.description": [
    {
      "type": 0,
      "value": "Customize the experience: add your company’s logo, colors, and background to the new tab page. Push your announcements: Company-wide updates and news to every user’s new tab. Users stay in control of their browsing experience by customizing or opting out in their extension settings."
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.vitafleet-spotlight.description": [
    {
      "type": 0,
      "value": "Rovo extension with company branding and annoucements."
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.why-rovo.description": [
    {
      "type": 0,
      "value": "Rovo is Atlassian’s AI. It is designed for teamwork, connecting knowledge, people, and action to move work forward. Today Rovo includes Enterprise Search, Chat, Studio, Agents, and Skills and can be connected to 50+ 3rd party tools."
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.your-team-will-thank-you": [
    {
      "type": 0,
      "value": "Your team will thank you."
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.subject": [
    {
      "type": 0,
      "value": "🚀 Get the Rovo extension ready for your whole team"
    }
  ],
  "rovo-extension-gdocs-definitions-install-cta-flag.flag-description": [
    {
      "type": 0,
      "value": "Define company jargon in Google Docs, with the Rovo browser extension."
    }
  ],
  "rovo-extension-gdocs-definitions-install-cta-flag.flag-dismiss-button-label": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "rovo-extension-gdocs-definitions-install-cta-flag.flag-download": [
    {
      "type": 0,
      "value": "Download extension"
    }
  ],
  "rovo-extension-gdocs-definitions-install-cta-flag.flag-gif-alt": [
    {
      "type": 0,
      "value": "Gif showing AI definitions available by the Rovo extension for acronyms inside a Google Docs document."
    }
  ],
  "rovo-extension-gdocs-definitions-install-cta-flag.flag-title": [
    {
      "type": 0,
      "value": "Get definitions in your Gdocs"
    }
  ],
  "rovo-extension-install-cta-left-nav.chrome-icon-alt": [
    {
      "type": 0,
      "value": "Google Chrome Icon"
    }
  ],
  "rovo-extension-install-cta-left-nav.description.copy-version-b": [
    {
      "type": 0,
      "value": "Ask about your projects, work policies, or anything about your company. Rovo Chat from any tab."
    }
  ],
  "rovo-extension-install-cta-left-nav.description.copy-version-c": [
    {
      "type": 0,
      "value": "50K+ workers use it to chat with AI that understands their company."
    }
  ],
  "rovo-extension-install-cta-left-nav.dismiss-label": [
    {
      "type": 0,
      "value": "Dismiss message"
    }
  ],
  "rovo-extension-install-cta-left-nav.heading.copy-version-b": [
    {
      "type": 0,
      "value": "Get answers for work, anywhere"
    }
  ],
  "rovo-extension-install-cta-left-nav.heading.copy-version-c": [
    {
      "type": 0,
      "value": "Unlock Rovo in every tab"
    }
  ],
  "rovo-extension-install-cta-left-nav.link": [
    {
      "type": 0,
      "value": "Get the browser extension"
    }
  ],
  "rovo-extension-install-cta-left-nav.rovo-icon-alt": [
    {
      "type": 0,
      "value": "Rovo Icon"
    }
  ],
  "rovo-growth-nudge-end-user-highly-connected-apps.action.connect": [
    {
      "type": 0,
      "value": "Connect "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "rovo-growth-nudge-end-user-highly-connected-apps.action.connect.variant2": [
    {
      "type": 0,
      "value": "Connect now"
    }
  ],
  "rovo-growth-nudge-end-user-highly-connected-apps.description.high-percentage.variant2": [
    {
      "type": 0,
      "value": "90% of your team works with shared content. Connect for a smarter Search and Chat that includes work you’ve seen. "
    }
  ],
  "rovo-growth-nudge-end-user-highly-connected-apps.description.medium-high-percentage.variant1": [
    {
      "type": 0,
      "value": "Connect your account to search smarter and get more in-depth summaries in Chat."
    }
  ],
  "rovo-growth-nudge-end-user-highly-connected-apps.description.medium-high-percentage.variant2": [
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": "% of your team works with shared content. Connect for a smarter Search and Chat that includes work you’ve seen. "
    }
  ],
  "rovo-growth-nudge-end-user-highly-connected-apps.description.variant1": [
    {
      "type": 0,
      "value": "Get better summaries in Search and Chat from work that was shared with you."
    }
  ],
  "rovo-growth-nudge-end-user-highly-connected-apps.description.variant2": [
    {
      "type": 0,
      "value": "Get better summaries in Search and Chat that includes files from work you’ve seen. "
    }
  ],
  "rovo-growth-nudge-end-user-highly-connected-apps.title.high-percentage.variant1": [
    {
      "type": 0,
      "value": "90% of your team has connected apps like "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "rovo-growth-nudge-end-user-highly-connected-apps.title.low-percentage.variant1": [
    {
      "type": 0,
      "value": "Your team connected "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "rovo-growth-nudge-end-user-highly-connected-apps.title.low-percentage.variant2": [
    {
      "type": 0,
      "value": "Your team is using "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "rovo-growth-nudge-end-user-highly-connected-apps.title.medium-percentage.variant1": [
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": "% of your team has connected apps like "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "rovo-growth-nudge-end-user-highly-connected-apps.title.medium-percentage.variant2": [
    {
      "type": 0,
      "value": "Connect "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "rovo.search.inline-3p.banner-image-alt": [
    {
      "type": 0,
      "value": "Illustration showing "
    },
    {
      "type": 1,
      "value": "connectorName"
    },
    {
      "type": 0,
      "value": " integration with Atlassian search"
    }
  ],
  "rovo.search.inline-3p.connect": [
    {
      "type": 0,
      "value": "Connect "
    },
    {
      "type": 1,
      "value": "connectorName"
    }
  ],
  "rovo.search.inline-3p.connect-later": [
    {
      "type": 0,
      "value": "Connect later"
    }
  ],
  "rovo.search.inline-3p.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "rovo.search.inline-3p.full-connector.admin-blessed.body": [
    {
      "type": 0,
      "value": "Finish connecting your account to unlock search results with context from all your files."
    }
  ],
  "rovo.search.inline-3p.full-connector.admin-blessed.heading": [
    {
      "type": 0,
      "value": "Your admin added "
    },
    {
      "type": 1,
      "value": "connectorName"
    }
  ],
  "rovo.search.inline-3p.full-connector.fomo.body-v2": [
    {
      "type": 0,
      "value": "Join your team in a smarter search. Connect your account to find answers hidden in your team's work."
    }
  ],
  "rovo.search.inline-3p.full-connector.fomo.heading": [
    {
      "type": 0,
      "value": "Your team is getting results you might be missing"
    }
  ],
  "rovo.search.inline-3p.full-connector.search-in-one-place.body": [
    {
      "type": 0,
      "value": "Connect your account to see missing results, including files and docs you already have access to."
    }
  ],
  "rovo.search.inline-3p.full-connector.search-in-one-place.heading": [
    {
      "type": 0,
      "value": "See richer search results in every search"
    }
  ],
  "rovo.search.inline-3p.smart-link-connector.fomo.body-v2": [
    {
      "type": 0,
      "value": "Most of your team's Smart Links don't appear in search. Connect "
    },
    {
      "type": 1,
      "value": "connectorName"
    },
    {
      "type": 0,
      "value": " to expand your search."
    }
  ],
  "rovo.search.inline-3p.smart-link-connector.fomo.heading": [
    {
      "type": 0,
      "value": "Your team is getting results you might be missing"
    }
  ],
  "rovo.search.inline-3p.smart-link-connector.recency-1.body-v2": [
    {
      "type": 0,
      "value": "Connect your account to find work you've seen and its related content."
    }
  ],
  "rovo.search.inline-3p.smart-link-connector.recency-1.heading": [
    {
      "type": 0,
      "value": "Missing that recent "
    },
    {
      "type": 1,
      "value": "connectorName"
    },
    {
      "type": 0,
      "value": " result?"
    }
  ],
  "rovo.search.inline-3p.smart-link-connector.recency-2.body": [
    {
      "type": 0,
      "value": "Connect your account to find "
    },
    {
      "type": 1,
      "value": "connectorName"
    },
    {
      "type": 0,
      "value": " links you've seen before."
    }
  ],
  "rovo.search.inline-3p.smart-link-connector.recency-2.heading": [
    {
      "type": 0,
      "value": "See richer results in every search"
    }
  ],
  "rovo.search.inline-3p.smart-link-connector.social-proof-high.body": [
    {
      "type": 1,
      "value": "teamUsagePercentage"
    },
    {
      "type": 0,
      "value": "% of your team works with shared content. Connect your account so work shared via Smart Links shows up in Search."
    }
  ],
  "rovo.search.inline-3p.smart-link-connector.social-proof-high.heading-v2": [
    {
      "type": 0,
      "value": "Find missing results from your team's content"
    }
  ],
  "rovo.search.inline-3p.smart-link-connector.social-proof-low.body": [
    {
      "type": 0,
      "value": "Connect your account to search across "
    },
    {
      "type": 1,
      "value": "connectorName"
    },
    {
      "type": 0,
      "value": " files shared by your team via Smart Links."
    }
  ],
  "rovo.search.inline-3p.smart-link-connector.social-proof-low.heading": [
    {
      "type": 0,
      "value": "Find what's hidden in your team's shared links"
    }
  ],
  "rovo.search.inline-authorization-fail": [
    {
      "type": 0,
      "value": "Failed to connect to "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "rovo.search.inline.authorization-success": [
    {
      "type": 0,
      "value": "Account connected to "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "rovo.search.quick-find-3p.connect": [
    {
      "type": 0,
      "value": "Connect "
    },
    {
      "type": 1,
      "value": "connectorName"
    }
  ],
  "rovo.search.quick-find-3p.connect-later": [
    {
      "type": 0,
      "value": "Connect later"
    }
  ],
  "rovo.search.quick-find-3p.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "rovo.search.quick-find-3p.full-connector.admin-blessed-missing-results.body": [
    {
      "type": 0,
      "value": "Connect to see missing results"
    }
  ],
  "rovo.search.quick-find-3p.full-connector.admin-blessed-missing-results.heading": [
    {
      "type": 0,
      "value": "Your admin added "
    },
    {
      "type": 1,
      "value": "connectorName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "rovo.search.quick-find-3p.full-connector.admin-blessed-recency.body": [
    {
      "type": 0,
      "value": "Connect to find recent files"
    }
  ],
  "rovo.search.quick-find-3p.full-connector.admin-blessed-recency.heading": [
    {
      "type": 0,
      "value": "Your admin added "
    },
    {
      "type": 1,
      "value": "connectorName"
    }
  ],
  "rovo.search.quick-find-3p.full-connector.search-in-one-place.heading": [
    {
      "type": 0,
      "value": "See richer results in every search"
    }
  ],
  "rovo.search.quick-find-3p.smart-link-connector.recency.heading": [
    {
      "type": 0,
      "value": "See richer results every search"
    }
  ],
  "rovo.search.quick-find-3p.smart-link-connector.social-proof-high.heading": [
    {
      "type": 1,
      "value": "teamUsagePercentage"
    },
    {
      "type": 0,
      "value": "% of your team works with shared content"
    }
  ],
  "rovo.search.quick-find-3p.smart-link-connector.social-proof-low.heading": [
    {
      "type": 0,
      "value": "Connect to find more results that surface your team's work"
    }
  ],
  "rovo.search.quick-find-authorization-fail": [
    {
      "type": 0,
      "value": "Failed to connect to "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "rovo.search.quick-find.authorization-success": [
    {
      "type": 0,
      "value": "Account connected to "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": "."
    }
  ]
}